import React from "react"
import PageTemplate from "../components/pageTemplate"
import { Container, Row, Col } from "reactstrap"
import { FaCode, FaRegClipboard, FaRegAddressBook, FaHome, FaHandsHelping,FaProjectDiagram } from "react-icons/fa"
import { 
  RiSettings6Line,
  RiDeleteBack2Fill,
  RiDatabase2Line
 } from "react-icons/ri"
import { 
  BiTransfer, BiCalendarEdit, BiCalendarCheck
 } from "react-icons/bi"
import { 
  HiOutlineDocumentText
 } from "react-icons/hi"
import { 
  FiTrash2
 } from "react-icons/fi"
import Box from "../components/box"
import SEO from "../components/seo"
import Button from "../components/btn"
import Form from "../components/form"
import Hr from "../components/hr"

// import "bootstrap/dist/css/bootstrap.min.css"

let Portfolio = ({ title, description, example }) => (
  <Col xs={12} md={12} className="mb-4">
    {/* <Link to="/"> */}
        {/* <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#b23a48'}}/> */}
        
        <p className="mt-3" style={{fontWeight:'bold'}}>{title}</p>
        <p className="mt-3">{description}</p>
        
        <p className="mt-3">{example}</p>
    {/* </Link> */}
  </Col>
)

let ProductInfo = ({ Icon = FaHome, title, content }) => (
  <div className="d-flex mb-4">
    {/* <div><FaCode size={20} style={{color: '#f77f00'}} /></div> */}
    <div>
      <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#A00429'}}/>
    </div>
    <div className="ml-3">
      <p className="m-0" style="font-weight: bold;">{title}</p>
      <p className="m-0 text-muted">{content}</p>
    </div>
  </div>
)

let IconProduct = ({ Icon = FaHome }) => (
  <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#A00429'}}/>
  )

let Product = () => (
  <PageTemplate title="Product">
    <SEO title="Product" />
    <Container className="py-5">
    <h2 className="text-center mb-5" style={{fontWeight:'900'}}>Asset Management System</h2>
      <Col xs={12} md={12} className="mb-4">
      <Row>
        <Box>
          <Row>
            <Col xs={12} md={4} className="mb-4">
              <p className="mt-3" style={{fontWeight:'bold'}}>MOVABLE ASSET</p>
              <p className="mt-3">Movable Assets means assets or equipment which can
              be moved or removed from one place to another easily
              including Movable Assets supplied together with the
              preparation of the building or other infrastructure.</p>
            </Col>
            <Col xs={12} md={4} className="mb-4">
              <p className="mt-3" style={{fontWeight:'bold'}}>CAPITAL ASSET</p>
              <p className="mt-3">Movable Assets with an original
              acquisition price of RM 2,000 (Ringgit Malaysia Two
              Thousand) or more per unit.</p>
            </Col>
            <Col xs={12} md={4} className="mb-4">
              <p className="mt-3" style={{fontWeight:'bold'}}>CAPITAL PROPERTIES</p>
              <p className="mt-3">Movable Assets whose
                original acquisition price is less than RM 2,000 (Ringgit
                Malaysia Two Thousand) per unit.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={FaRegClipboard} title="ACCEPTANCE" content="Assets received should be carefully inspected to ensure that the assets meet the specified specifications."></ProductInfo>
            </Col>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={HiOutlineDocumentText} title="REGISTRATION" content="Assets received through purchase, hire purchase, through gift, transfer and through legal process or agreement must be registered."></ProductInfo>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={RiDatabase2Line} title="USE, STORAGE AND INSPECTION" content="Records of use, storage and periodic inspection of assets that have been registered."></ProductInfo>
            </Col>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={RiSettings6Line} title="MAINTENANCE" content="Identify and manage Movable Assets that require maintenance"></ProductInfo>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={BiTransfer} title="TRANSFER" content="The process for transferring ownership of Movable Assets between a Federal Government Agency and another Federal Government Agency"></ProductInfo>
            </Col>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={FiTrash2} title="DISPOSAL" content="The process of recording and managing asset’s disposal as stated in the circular."></ProductInfo>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={RiDeleteBack2Fill} title="WRITE-OFF" content="The process of recording and managing assets that is lost for as stated in the circular."></ProductInfo>
            </Col>
          </Row>
        </Box>
      </Row>
      </Col>
        <div className="py-5">
            <Container>
              <Row className="d-flex justify-content-center">
                <Col md={8}>
                  <Box style={{ textAlign: "left" }}>
                    <h3 className="text-center">Contact Us</h3>
                    <Hr />
                    <Form />
                  </Box>
                </Col>
              </Row>
            </Container>
          </div>
    </Container>
  </PageTemplate>
)

export default Product